/* eslint-disable import/no-cycle */
import { IAddress } from './transaction';
import { IUser } from './user';

export interface IUsersLocations {
  id: string;
  manageUsersPermission: boolean;
  manageLocationsPermission: boolean;
  clientPermission: boolean;
  location: ILocation;
  user: IUser;
}

export interface IUsersLocationsInput {
  manageUsersPermission: boolean;
  manageLocationsPermission: boolean;
  clientPermission: boolean;
  location?: ILocation;
  user: string;
}

export interface ILocation {
  id: string;
  name?: string;
  number?: string;
  address?: IAddress;
  usersLocations?: IUsersLocations[];
  returnShippingAccount?: {
    accountNo: string;
  };
}

export enum LocationRole {
  NONE = 'none',
  LOCATION_ADMIN = 'locationAdmin',
  EMPLOYEE = 'employee',
}
